import { VARIANT_TUNNEL_STORAGE_KEY } from "../constants";

export function getVariantValue(): string | null {
  const keys = [
    VARIANT_TUNNEL_STORAGE_KEY,
    VARIANT_TUNNEL_STORAGE_KEY.toLowerCase(),
    VARIANT_TUNNEL_STORAGE_KEY.toUpperCase(),
  ];
  for (const key of keys) {
    const value = localStorage.getItem(key);
    if (value) return value;
  }
  return null;
}
